<template>
  <Modal
    :title="edit ? $t('series.edit') : $t('series.add')"
    @ok="(l) => (this.edit ? update(l) : save(l))"
    :value="value"
    :okText="edit ? $t('series.edit') : $t('series.add')"
    @input="$emit('input', $event)"
  >
    <PageTitle
      :description="
        edit ? $t('series.editDescription') : $t('series.addDescription')
      "
    ></PageTitle>
    <BaseInput
      class="u-margin-top-small"
      block
      input-id="title"
      :label="$t('series.name')"
      size="sm"
      :placeholder="$t('series.namePlaceholder')"
      v-model="title"
      :icon="'architecture'"
      :mandotary="validActivated"
    ></BaseInput>
  </Modal>
</template>

<script>
import Modal from "../Base/Modal.vue";
import PageTitle from "@/components/Shared/PageTitle/index.vue";
import BaseInput from "@/components/Base/Inputs/BaseInput.vue";
import Requests from "@/services/Requests";
export default {
  components: {
    Modal,
    PageTitle,
    BaseInput,
  },
  props: {
    value: {
      default: false,
    },
    edit: {
      default: false,
      type: Boolean,
    },
    form: {
      default: () => ({
        id: null,
        title: "",
      }),
    },
  },
  data() {
    return {
      title: this.form.title,
      validActivated: false,
    };
  },
  watch: {
    title(value) {
      this.validActivated = value ? true : false;
    },
    value(value) {
      console.log(value, "valü");
      if (value) {
        this.checkProps();
      }
    },
  },

  methods: {
    async save(loading) {
      if (!this.validation()) {
        return;
      }
      loading(true);
      const response = await Requests.Series.Create({
        title: this.title,
        isActive: true,
      });
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("series.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    async update(loading) {
      if (!this.validation()) {
        return;
      }
      loading(true);
      const response = await Requests.Series.Update(
        {
          title: this.title,
          seriesId: this.series?.id,
        },
        { params: { id: this.form.id } }
      );
      if (response.message === "OK") {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t("series.success"),
          variant: "success",
          duration: 2500,
        });
        this.$emit("refresh");
        this.$emit("input", false);
      } else {
        this.$store.dispatch("SET_ACTION_MODAL", {
          isLoading: false,
          status: true,
          message: this.$t(`message.${response.message}.description`),
          variant: "danger",
          duration: 2500,
        });
      }
      loading(false);
    },
    validation() {
      if (this.title) {
        return true;
      }
      return false;
    },
    async checkProps() {
      if (this.edit) {
        this.title = this.form.title;
      }
    },
  },
  mounted() {
    this.checkProps();
  },
};
</script>

<style></style>
